import { Statsig } from 'statsig-react';
import appendQueryString from '../appendQueryString';
import { gTagEvent } from '../googleAnalyticsHelper';
import { applyGanalyticsTracking } from '../propagateQueryParams';
import { safeNavigationHref } from '../safeNavigationHref';

interface NavigateToCohostProps {
  idealMember?: string;
  event: React.MouseEvent<HTMLButtonElement, MouseEvent>;
  sectionLabel?: string;
  mode?: string;
  queryString?: Record<string, string>;
  statsigEvent?: string;
}

export const navigateToCohost = ({
  event,
  idealMember,
  mode,
  sectionLabel,
  queryString,
  statsigEvent,
}: NavigateToCohostProps): void => {
  let cohostUrl = mode
    ? `https://cohost.mn.co/?plan=free-trial&mode=${mode}&ideal_members=${encodeURIComponent(idealMember)}`
    : `https://cohost.mn.co/?plan=free-trial&ideal_members=${encodeURIComponent(idealMember)}`;

  if (queryString) {
    cohostUrl = appendQueryString(cohostUrl, queryString);
  }

  const queryPropagatedUrl = safeNavigationHref(cohostUrl);
  const gtagEventName = mode ? `${mode}_name_generator_submit` : 'input_name_generator_submit';

  gTagEvent(gtagEventName, {
    category: 'Link Click',
    label: `Ideal member submit ${sectionLabel} | ${idealMember}`,
  });

  if (statsigEvent) {
    Statsig.logEvent(statsigEvent, 1);
  }

  const navigate = applyGanalyticsTracking<HTMLButtonElement>(queryPropagatedUrl, true);
  navigate(event);
};
